import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 358C06F7-7E39-4023-A9FC-2C02F275B84B
 * name alpha-k
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaKIcon = createSvgIcon(<><path d="M9,7V17H11V13.67L13,17H15L12,12L15,7H13L11,10.33V7H9Z" /></>, 'AlphaKIcon');
export default AlphaKIcon